
import TableList from "@components/templates/tablelist";
import { HttpGetAgreementList, HttpDeleteAgreement } from "@/service/managechannel/managechannel";
import { mapGetters } from "vuex";
import comIndex from './update'
// import mixin from './mixin'
export default {
    mixins: [TableList],
    components: {
        comIndex,
    },
    data () {
        return {
            // totals: 0,
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
            },
            exportdata: {},
            Searchs: {
                show: true,
                labelWidth: 180,
            },
            Plugins: { show: true },

        };
    },
    methods: {
        ajaxRequest: HttpGetAgreementList,
        interceptRequest (params) {
            return this.handleParams(params);
        },
        handleParams (params, isExport = false) {
            let search = {
                ...params.search
            };
            if (search.BT_cycle) {
                let cycle = search.BT_cycle;
                cycle = cycle.split(' ~ ');
                search.GE_startTime = cycle[0];
                search.LE_endTime = cycle[1];
            }
            else {
                delete search.GE_startTime;
                delete search.LE_endTime;
            }
            delete search.BT_cycle;
            if (isExport) {
                params = {
                    ...params,
                    rows: 3000
                }
            }
            return {
                ...params,
                search
            };
        },
        handleOperates (params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'agreementUpdate',
                        params: { type: "add" },
                    });
                    break;
                case "edit":
                    var url = this.$router.resolve({
                        name: "agreementUpdate",
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "query":
                    this.operate = {
                        title: '查看',
                        show: true,
                        width: 1200,
                        component: "comIndex",
                        activeid: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case "queryBlank":
                    var url = this.$router.resolve({
                        name: "agreementUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case 'exportQuery':
                    this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v2/AccountAgreement/export", this.handleParams(this.formData, true), {
                        download: true,
                    }).catch(err => {
                        // this.$VMessage.error(err.message);
                    })
                    break
                case "importExcel":
                    this.operate = {
                        show: true,
                        title: "导入数据",
                        showDesc: false,
                        component: "compUpload",
                        name: "excelFile",
                        showFooter: false,
                        action: process.env.VUE_APP_APIURL_BOSS + "/api/v2/AccountAgreement/import",
                        warningtitle:'批量更新时，账号，协议周期和Vendor Code不更新',
                        download: () => {
                            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/AccountAgreement/excel', {}, 'download')
                        },
                    };
                    break;
                case "delete":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: "删除",
                        width: 460,
                        params:{ids:params},
                        ajaxRequest:HttpDeleteAgreement
                    };
                    break;
            }
        },
        getOperateNodeMap (row) {
            const { id, disabledAt } = row
            return [{
                label: '查看',
                show: true,
                params: id,
                operate: 'query'
            }, {
                label: '编辑',
                show: disabledAt == 0,
                params: id,
                operate: 'edit'
            }, {
                label: '删除',
                show: true,
                params: id,
                operate: 'delete'
            },]
        },
    },
    computed: {
        ...mapGetters('diction', ['getProductList', 'getNewAccountList', 'getWarehouseList','getNewAccountIdList']),
        
        ToolsData () {
            return [
                {
                    name: "新增",
                    operate: "add",
                    theme: 'primary'
                },
                {
                    name: "批量导入",
                    operate: "importExcel",
                    theme: 'info'
                },
                {
                    name: "查询条件导出",
                    operate: "exportQuery",
                    theme: 'success'
                }
            ]
        },
        SearchsData () {
            return [
                {
                    label: "渠道名称",
                    key: 'EQ_accountId',
                    tag: 'vSelect',
                    options:this.getNewAccountIdList,
                    show: true,
                    props:{
                        filterable:true,
                        clearable:true,
                        // multiple:true
                    }
                },
                {
                    label: "渠道标识",
                    tag: 'vInput',
                    key: 'CN_accountFlag',
                    show: true,
                },
                {
                    label: "DA Agreement ID",
                    tag: 'vInput',
                    key: 'EQ_daAgreementId',
                    show: true,
                },
                {
                    label: "COOP Agreement ID",
                    tag: 'vInput',
                    key: 'EQ_coopAgreementId',
                },
                {
                    label: "Termsdiscount Agreement ID",
                    tag: 'vInput',
                    key: 'EQ_termsdiscountAgreementId',
                },
                {
                    label: "Freight Agreement ID",
                    tag: 'vInput',
                    key: 'EQ_freightAgreementId',
                },
                {
                    label: "AVS Agreement ID",
                    tag: "vInput",
                    key: "CN_avsAgreementId"
                },
                {
                    label: "Vendor Code",
                    tag: 'vInput',
                    key: 'EQ_vendorCode',
                },
                {
                    label: "Warehouse Code",
                    tag: 'vInput',
                    key: 'EQ_warehouseCode',
                },
                {
                    label: "Category",
                    tag: 'vInput',
                    key: 'EQ_category',
                },
                {
                    label: "周期协议",
                    tag: "vDatepicker",
                    props: {
                        type: "daterange",
                        format: "yyyy-mm-dd ~ yyyy-mm-dd",
                        confirm: false,
                    },
                    style: "width: 200px",
                    key: "BT_cycle"
                },
            ]
        },
        columns() {
            return  [
            {
                show:false,
                type: 'selection',
                width: 60,
                align: 'center',
            },{
                title: '操作',
                width: 90,
                render:this.getOperateNodes,
            },
            {
                title: '渠道名称',
                sortable: true,
                key:'accountTitle',
            },
            {
                title: '渠道标识',
                key: 'accountFlag',
            },
            {
                title: '扣点',
                render:(h,{row})=>{
                    return <div>
                        <div>DA:{row.daPointScale}%</div>
                        <div>Freight:{row.freightPointScale}%</div>
                        <div>COOP:{row.coopPointScale}%</div>
                        <div>Termsdiscount:{row.termsdiscountPointScale}%</div>
                        <div>AVS:{row.avsPointScale}%</div>
                    </div>
                }
            },
            {
                title: 'Vendor Code',
                key: 'vendorCode',
            },
            {
                title: 'Warehouse Code',
                key: 'warehouseCode',
            },
            {
                title: 'Category',
                key: 'category',
            },
            {
                title:'回款周期',
                key:'cycle'
            },
            {
                title: '更新时间',
                key:'updatedAt'
            },
        ];
        },

    },

};
